"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var GenericFormAutocompleteField = function (_a) {
    var item = _a.item, fields = _a.fields, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors;
    var arrayValues = lodash_1.get(fields, item.stateKey, "");
    // TODO - find a way to add isMultiple in auto-complete
    var isMultiple = item.isAutocompleteMultiple ? true : undefined;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Autocomplete_1.default, { key: item.stateKey, getOptionLabel: function (option) { return option.label || ""; }, options: item.options || [], id: item.idHtml || item.stateKey, 
            // multiple={isMultiple}
            value: fields
                ? lodash_1.get(fields, item.stateKey, "")
                : lodash_1.get(values, item.stateKey, ""), onChange: function (e, newValue) {
                if (setFieldValue)
                    setFieldValue(item.stateKey, newValue);
                if (changeField)
                    changeField({
                        key: item.stateKey,
                        value: newValue,
                    });
            }, getOptionSelected: function (option, value) {
                if (item.isAutocompleteMultiple) {
                    return arrayValues.some(function (item) { return item.value === option.value; });
                }
                return option.value === value.value;
            }, filterSelectedOptions: true, disabled: item.disabled, renderInput: function (params) { return (react_1.default.createElement(TextField_1.default, __assign({}, params, { variant: (item === null || item === void 0 ? void 0 : item.variant) || "outlined", label: item.label, fullWidth: true, disabled: item.disabled, error: !!lodash_1.get(errors, item.stateKey, null) ||
                    !!lodash_1.get(errors, item.error, null), helperText: lodash_1.get(errors, item.stateKey, null) ||
                    lodash_1.get(errors, item.error, null) }))); } })));
};
exports.default = GenericFormAutocompleteField;
//# sourceMappingURL=GenericAutocompleteField.js.map